import CompanyService from './CompanyService.js';

export default CompanyService;